<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">مديرين الموقع</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">مديرين الموقع</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="checkAccess('admins_create')" class="row">
          <div class="col text-end">
            <router-link to="/manager">
              <button type="button" class="btn btn-primary rounded-pill">
                <i class="bi bi-plus-circle ms-1"></i> إضافة مدير
              </button>
            </router-link>
          </div>
        </div>

        <!--FILTER-->
        <div class="card shadow card-warning card-outline mt-5">
          <div class="card-header">
            <button
              class="filter-btn w-100 text-start collapse-toggle"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#filterCard"
              aria-expanded="false"
              aria-controls="filterCard"
            >
              <i class="fa-solid fa-magnifying-glass"></i> بحث وتصفية
            </button>
          </div>

          <div class="collapse" id="filterCard">
            <form @submit.prevent="filterSubmit">
              <div class="card-body">
                <div class="row">
                  <div class="col-6 col-sm-3 mb-3">
                    <input v-model="searchName" type="text" class="form-control" placeholder="الاسم">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <input v-model="searchEmail" type="text" class="form-control" placeholder="البريد الإلكتروني">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <input v-model="searchMobile" type="text" class="form-control" placeholder="رقم الجوال">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select v-model="searchStatus" class="form-control">
                      <option :value="null">الحالة</option>
                      <option value="true">نشط</option>
                      <option value="false">غير نشط</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col text-end">
                    <button type="submit" class="btn btn-warning btn-sm"><i class="fa-solid fa-filter"></i> بحث وتصفية</button>
                    <button type="button" class="btn btn-light btn-sm ms-3" @click.prevent="clearFilter"><i class="fa-solid fa-filter-circle-xmark"></i> إلغاء</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div v-if="hasError" class="text-center pt-3">
          <errorAlert :messageAlert="message"  />
        </div>
        <div v-if="isLoading" class="text-center">
          <mainLoader />
        </div>
        <div v-else class="row justify-content-center overflow-auto mb-4 mt-5">
          <div class="col-12 col-md-11 pe-5">
            <table class="table table-striped table-hover text-center">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">الاسم</th>
                  <th scope="col">نوع الحساب</th>
                  <th scope="col">الحاله</th>
                  <th scope="col">اخر تحديث</th>
                  <th scope="col">التعديل</th>
                  <th v-if="checkAccess('admins_delete')" scope="col">الحذف</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in rows" :key="index">
                  <td class="counter"></td>
                  <td>{{ row.name }}</td>
                  <td>
                    <span class="badge bg-secondary">مسؤول</span>
                    <span v-if="row.isAccountManager" class="badge bg-info text-dark ms-1">مدير حساب</span>
                    <span v-if="row.isApprovalOfficer" class="badge bg-warning text-dark ms-1">مسؤول تعميد</span>
                    <span v-if="row.isExecutiveEmployee" class="badge bg-primary ms-1">موظف تنفيذي</span>
                  </td>
                  <td>{{ (row.isActive)? 'نشط' : 'غير نشط' }}</td>
                  <td>{{ $shortDate(row.updatedAt) }}</td>
                  <td>
                    <router-link v-if="checkAccess('admins_update')" :to="'/managerupdate/'+row.id">
                      <i class="bi bi-card-list"></i>
                    </router-link>
                    <router-link v-else :to="'/managerRead/'+row.id">
                      <i class="fa-regular fa-eye"></i>
                    </router-link>
                  </td>
                  <td v-if="checkAccess('admins_delete')">
                    <a @click.prevent="deleteItem(index, row.id)">
                      <i class="bi bi-archive text-red pointer-mouse"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-sm-11">
            <ul class="pagination">
              <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
              <li v-for="p in pages" :key="p" class="page-item">
                <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
              </li>
              <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
            </ul>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
import { toast, checkAccess } from '@/helpers/tools';
export default {
  name: "managerview",
  data(){
    return{
      isLoading: false,
      hasError: false,
      message: "",
      rows: [],
      currentPage: parseInt(this.$route.query.page) || 1,
      pages: [],
      searchName: this.$route.query.name || '',
      searchEmail: this.$route.query.email || '',
      searchMobile: this.$route.query.mobile || '',
      searchStatus: this.$route.query.status ?? null,
    }
  },
  
  methods: {
    checkAccess, 
    getData(){
      this.isLoading = true;
      this.hasError = false;

      const params = { page: this.currentPage };
      const name = this.searchName.trim();
      const email = this.searchEmail.trim();
      const mobile = this.searchMobile.trim();

      if (name)
        params.name = name;
      if (email)
        params.email = email;
      if (mobile)
        params.mobile = mobile;
      if (this.searchStatus !== null && this.searchStatus !== '')
        params.isActive = this.searchStatus;

      this.$router.replace({
        query: {
          page: this.currentPage,
          ...(name ? { name } : {}),
          ...(email ? { email } : {}),
          ...(mobile ? { mobile } : {}),
          ...(this.searchStatus !== null && this.searchStatus !== '' ? { status: this.searchStatus } : {}),
        },
      }).catch(() => {});

      this.$http.get('/api/admin/admins/list', {
        params,
      }).then(res => {
        // console.log(res);
        this.rows = res.data.admins;
        this.pages = res.data.pages ?? [this.currentPage];
        this.isLoading = false;
      }).catch (err => {
        this.message = this.$globalError(err);
        this.hasError = true;
        this.isLoading = false;
        window.scroll(0,0);
      });
    },
    deleteItem(index, id) {
      this.$swal.fire({
        title: "هل تريد تأكيد حذف السجل ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http.delete(`/api/admin/admins/delete/${id}`).then(({data}) => {
            this.rows.splice(index, 1);
            toast('تم حذف السجل بنجاح', 'success');
          }).catch(err => {
            toast('غير قادر على حذف السجل');
          });
        }
      });
    },
    nextPage(){
      this.currentPage += 1;
      this.getData();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getData();
    },
    goToPage(num){
      this.currentPage = num;
      this.getData();
    },
    filterSubmit(){
      this.currentPage = 1;
      this.getData();
    },
    clearFilter(){
      this.currentPage = 1;
      this.searchName = '';
      this.searchEmail = '';
      this.searchMobile = '';
      this.searchStatus = null;
      this.$router.replace({ query: {} }).catch(() => {});
      this.getData();
    },
  },
  created(){
    this.getData();
  }
}
</script>